import { createFileRoute, Link } from '@tanstack/react-router';
import { CheckCircle, Mail } from 'lucide-react';
import { useState } from 'react';

import { ExperienceBadge } from '@/components/experience-badge';
import { AuthContainer } from '@/components/shared';
import { Button } from '@/components/ui/button';

import { LoginForm } from './-components/login-form';

export const Route = createFileRoute('/(auth)/login/')({
  component: LoginPage,
});

function LoginPage() {
  const [sentToEmail, setSentToEmail] = useState<string | null>(null);

  const handleSuccess = (email: string) => {
    setSentToEmail(email);
  };

  const handleTryAgain = () => {
    setSentToEmail(null);
  };

  // Show success state after email is sent
  if (sentToEmail) {
    return (
      <AuthContainer>
        <div className="space-y-6 text-center">
          <div className="bg-primary/10 mx-auto flex h-16 w-16 items-center justify-center rounded-full">
            <CheckCircle className="text-primary h-8 w-8" />
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-semibold tracking-tight">
              Verifique seu email
            </h1>
            <p className="text-muted-foreground text-sm">
              Enviamos um link de acesso para{' '}
              <span className="text-foreground font-medium">{sentToEmail}</span>
            </p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Mail className="text-muted-foreground mt-0.5 h-5 w-5 shrink-0" />
              <p className="text-muted-foreground text-left text-sm">
                Clique no link enviado para seu email para entrar na sua conta.
                O link expira em 10 minutos.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3 text-center">
          <Button variant="outline" onClick={handleTryAgain} className="w-full">
            Usar outro email
          </Button>
          <div className="flex flex-col space-y-2 pt-6 text-center">
            <Link
              to="/"
              className="text-muted-foreground hover:text-primary text-sm"
            >
              Voltar para a página inicial
            </Link>
            <ExperienceBadge />
          </div>
        </div>
      </AuthContainer>
    );
  }

  return (
    <AuthContainer>
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          Entre na sua conta
        </h1>
        <p className="text-muted-foreground text-sm">
          Enviaremos um link de acesso para seu email
        </p>
      </div>

      <LoginForm onSuccess={handleSuccess} />

      <p className="text-muted-foreground text-center text-sm">
        Não tem uma conta?{' '}
        <Link to="/registration" className="text-primary hover:underline">
          Criar conta
        </Link>
      </p>

      <div className="flex flex-col space-y-2 text-center">
        <Link
          to="/"
          className="text-muted-foreground hover:text-primary text-sm"
        >
          Voltar para a página inicial
        </Link>
        <ExperienceBadge />
      </div>
    </AuthContainer>
  );
}
